import { TOptionsItem } from "@opm/components/FilterCommon/types";
import { categoryTranslate } from "@opm/components/FilterCommon/utils";
import { useState, useMemo } from "react";

export function useTranslateHashtagCategory({
  type = 'hashtag',
}: {
  type: 'hashtag' | 'video';
}) {
  const [categoryList, setCategoryList] = useState<Array<TOptionsItem>>([]);

  function backCondConfig(data: any) {
    const key =
      type === 'hashtag'
        ? 'marketing_hub_hashtag_config_time_range_category'
        : 'marketing_hub_video_config_time_range_category';
    const list = Object.values(data?.[key] || {}).flat(2);

    setCategoryList(
      list.map((item: any) => {
        return {
          text: item.category_en,
          textCn: item.category_zh,
          value: item.category_en,
        };
      }),
    );
  }

  const translateCategory = useMemo(() => {
    return categoryTranslate(categoryList);
  }, [categoryList]);

  return { backCondConfig, translateCategory };
}